import { TreePine, Tractor, BrickWall, Leaf, Sprout, Truck, ClipboardCheck, Car, Route, Trees, ArrowRight } from "lucide-react";
import { SERVICES, PHOTOS } from "@/data";

const ICONS = {
  "land-clearing": TreePine,
  excavation: Tractor,
  hardscaping: BrickWall,
  landscaping: Leaf,
  hydroseeding: Sprout,
  aggregate: Truck,
  maintenance: ClipboardCheck,
  driveway: Car,
  trails: Route,
  "forestry-mulching": Trees,
};

const IMAGE_CARDS = {
  "land-clearing": PHOTOS.forestTrail,
  hardscaping: PHOTOS.armourWall,
};

export const Services = () => {
  return (
    <section id="services" className="bg-[#F8FAFC] py-24" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <span className="font-mono-accent text-xs uppercase tracking-[0.2em] text-[#D97706]">
            What We Do
          </span>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#16283C] mt-3 uppercase">
            Heavy Equipment. Fine Finish.
          </h2>
          <p className="mt-4 text-base text-slate-600 leading-relaxed">
            From raw bush lot to polished cottage yard — one crew, one call, every service your property needs.
          </p>
        </div>

        <div className="grid md:grid-cols-6 gap-5" data-testid="services-grid">
          {SERVICES.map((service, i) => {
            const Icon = ICONS[service.id];
            const bgImage = IMAGE_CARDS[service.id];
            const isLast = i === SERVICES.length - 1;
            const tailOdd = (SERVICES.length - 5) % 2 === 1;
            const spanClass =
              i === 0
                ? "md:col-span-4"
                : i <= 4
                ? "md:col-span-2"
                : tailOdd && isLast
                ? "md:col-span-6"
                : "md:col-span-3";

            if (bgImage) {
              return (
                <a
                  key={service.id}
                  href="#quote"
                  data-testid={`service-card-${service.id}`}
                  className={`group relative overflow-hidden rounded-2xl min-h-[260px] flex flex-col justify-end p-7 ${spanClass}`}
                >
                  <div
                    className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
                    style={{ backgroundImage: `url(${bgImage})` }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0C1827]/95 via-[#0C1827]/40 to-transparent" />
                  <div className="relative">
                    <Icon size={28} className="text-[#F5A623] mb-3" />
                    <h3 className="font-display font-bold text-xl text-white">{service.name}</h3>
                    <p className="mt-2 text-sm text-slate-300 leading-relaxed">{service.desc}</p>
                    <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[#F5A623]">
                      Get a quote <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
                    </span>
                  </div>
                </a>
              );
            }

            return (
              <a
                key={service.id}
                href="#quote"
                data-testid={`service-card-${service.id}`}
                className={`group bg-white border border-[#E2E8F0] rounded-2xl p-7 hover:border-[#F5A623] hover:shadow-xl hover:shadow-[#F5A623]/10 hover:-translate-y-1 transition-[border-color,box-shadow,transform] duration-300 ${spanClass}`}
              >
                <div className="h-12 w-12 rounded-xl bg-[#16283C] flex items-center justify-center mb-5 group-hover:bg-[#F5A623] transition-colors duration-300">
                  <Icon size={24} className="text-[#F5A623] group-hover:text-[#0C1827] transition-colors duration-300" />
                </div>
                <h3 className="font-display font-bold text-xl text-[#16283C]">{service.name}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{service.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[#D97706]">
                  Get a quote <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
